// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-wrapper {
  position: relative;
}
.search-wrapper .suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  max-height: 240px;
  overflow-y: auto;
}
.search-wrapper .suggestions-dropdown li {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.search-wrapper .suggestions-dropdown li:last-child {
  border-bottom: none;
}
.search-wrapper .suggestions-dropdown li:hover {
  background-color: #f5f5f5;
}
.search-wrapper .suggestions-dropdown li .suggestion-main {
  font-size: 14px;
  color: #222;
}
.search-wrapper .suggestions-dropdown li .suggestion-secondary {
  font-size: 12px;
  color: #777;
  margin-top: 2px;
}

.expand-body {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.expand-body.is-open {
  max-height: 2000px;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/map/map.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,yCAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AACN;AACM;EACE,mBAAA;AACR;AAEM;EACE,yBAAA;AAAR;AAGM;EACE,eAAA;EACA,WAAA;AADR;AAIM;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAFR;;AAQA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,iEACE;AANJ;AASE;EACE,kBAAA;EACA,UAAA;AAPJ","sourcesContent":[".search-wrapper {\r\n  position: relative;\r\n\r\n  .suggestions-dropdown {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 1000;\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    background: #fff;\r\n    border: 1px solid #ccc;\r\n    border-top: none;\r\n    border-radius: 0 0 4px 4px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\r\n    max-height: 240px;\r\n    overflow-y: auto;\r\n\r\n    li {\r\n      display: flex;\r\n      flex-direction: column;\r\n      padding: 8px 12px;\r\n      cursor: pointer;\r\n      border-bottom: 1px solid #f0f0f0;\r\n\r\n      &:last-child {\r\n        border-bottom: none;\r\n      }\r\n\r\n      &:hover {\r\n        background-color: #f5f5f5;\r\n      }\r\n\r\n      .suggestion-main {\r\n        font-size: 14px;\r\n        color: #222;\r\n      }\r\n\r\n      .suggestion-secondary {\r\n        font-size: 12px;\r\n        color: #777;\r\n        margin-top: 2px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.expand-body {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  transition:\r\n    max-height 0.3s ease-in-out,\r\n    opacity 0.3s ease-in-out;\r\n\r\n  &.is-open {\r\n    max-height: 2000px;\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
